import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/recharge/cn-new-year-2024/Index.vue')

const indexRoute: RouteConfig = {
  path: '/activity/recharge',
  name: 'activity_recharge',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '新年首充礼包',
  },
}

export default [indexRoute]
